import React, { useState } from "react";
import useDocumentList from "../../hooks/useDocumentList";
import checkIfUserHasAccess from "../common/UserCheckAccess";
import InvoiceDataGrid from "../invoiceList/InvoiceDataGrid";
import InvoiceActivityLogs from "../invoiceList/InvoiceActivityLogs";
import DocumentHeader from "../invoiceList/DocumentHeader";

const BranchTransferInList = () => {
    const handleExport = () => {
        exportDocumentList();
    };
    const [p1Value, setP1Value] = useState("ALL");
    const [modalType, setModalType] = useState(null);

    const {
        config,
        searchTerm,
        setSearchTerm,
        searchType,
        setSearchType,
        showSidebar,
        setShowSidebar,
        columnVisibilityModel,
        setColumnVisibilityModel,
        documentData,
        columns,
        rows,
        selectionModel,
        setSelectionModel,
        selectedRowData,
        setSelectedRowData,
        loading,
        handleEdit,
        exportDocumentList,
        handleView,
        pageNumber,
        setPageNumber,
        currentEnd,
        currentStart,
        totalCount,
        refreshDocumentList,
    } = useDocumentList({
        docType: "BTIN",
        p1Value,
        p2Value: "-",
        docNoField: "TRIN_NO",
        editRoute: "/branch_transfer_in",
        screenCode: "BTICOUNT",
        initialSearchType: "-",
    });
    return (
        <div className=" bg-gray-50">
            <DocumentHeader
                showSidebar={showSidebar}
                setShowSidebar={setShowSidebar}
                BASE_URL={config.BASE_URL}
                COMPANY_CODE={config.COMPANY_CODE}
                DEPARTMENT={config.DEPARTMENT_NO}
                title="Branch Transfer In List"
                searchTerm={searchTerm}
                searchType={searchType}
                setSearchTerm={setSearchTerm}
                setSearchType={setSearchType}
                filteredDocs={documentData}
                showType={p1Value}
                setShowType={setP1Value}
                total={totalCount}
                onExport={handleExport}
                documentType={"BRANCHTRANSFER"}
                config={config}
                selectedRowData={selectedRowData}
                doctype="TROUT_NO"
                showFilter={false}
            />
            <div className="max-w-full mx-auto py-0 space-y-1">
                <div className="grid grid-cols-12 gap-4">
                    {showSidebar && (
                        <InvoiceActivityLogs
                            invoiceId={selectedRowData["PO NO"]}
                            COMPANY_CODE={config.COMPANY_CODE}
                            BASE_URL={config.BASE_URL}
                            modificationType={"POTIMELINE"}
                            printType={"POTPRINTIMELINE"}
                            DEPARTMENT={config.DEPARTMENT_NO}
                        />
                    )}
                    <div
                        className={`col-span-12 ${showSidebar ? "lg:col-span-9" : "lg:col-span-12"
                            } transition-all duration-300`}
                    >
                        <InvoiceDataGrid
                            rows={rows}
                            columns={columns}
                            loading={loading}
                            selectionModel={selectionModel}
                            setSelectionModel={setSelectionModel}
                            setSelectedRowData={setSelectedRowData}
                            selectedRowData={selectedRowData}
                            onEdit={handleEdit}
                            onView={handleView}
                            columnVisibilityModel={columnVisibilityModel}
                            setColumnVisibilityModel={setColumnVisibilityModel}
                            pageNumber={pageNumber}
                            setPageNumber={setPageNumber}
                            currentStart={currentStart}
                            currentEnd={currentEnd}
                            totalCount={totalCount}
                            showSidebar={showSidebar}
                            docLabel={"TROUT_NO"}
                            enableF5Action={false}
                            config={config}
                            refreshDocumentList={refreshDocumentList}
                            modalType={"close"}
                            setModalType={setModalType}
                            f5Mode={"POSETTLEMENT"}
                            showApproveReject={false}
                            reviewMode="PURCHASEORDER"
                            showEdit={true}

                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BranchTransferInList;
